import {
  BottomActions,
  RetakeTextContainer,
  RetakePromptText,
  RetakeButton,
} from "./styled"
import { useNavigate } from "react-router-dom"
import PATHS from "router/paths"

const ScanFailedBottomActions = () => {
  const navigate = useNavigate()

  const goToCreateMyFood = () => {
    navigate(PATHS.app.food.create)
  }

  return (
    <BottomActions>
      <RetakeTextContainer>
        <RetakePromptText>Want to add meal manually instead?</RetakePromptText>
        <RetakeButton onClick={goToCreateMyFood}>Create new meal </RetakeButton>
      </RetakeTextContainer>
    </BottomActions>
  )
}

export default ScanFailedBottomActions
